import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { Clinic, ClinicInput, ClinicState } from '@/types/clinic';

const initialState: ClinicState = {
	rawClinics: [],
	availableClinics: [],
	currentClinics: [],
	current: 'All',
};

interface ClinicActions {
	setClinics: (clinicsDetails: ClinicInput[]) => void;
	setRawClinics: (clinicsDetails: ClinicInput[]) => void;
	resetClinics: () => void;
}

// --- Store ---
export const useClinicStore = create<ClinicState & ClinicActions>()(
	devtools(
		persist(
			(set) => ({
				...initialState,

				setClinics: (clinicsDetails) => {
					// Transform login clinicsDetails to Clinic format
					const transformedClinics: Clinic[] = clinicsDetails.map((clinic) => ({
						accountid: clinic.id,
						name: clinic.name,
						ta_bypasssurcharges: clinic.ta_bypasssurcharges,
					}));
					set(() => ({ currentClinics: transformedClinics }));
				},
				setRawClinics: (clinicsDetails) => {
					const transformedClinics: Clinic[] = clinicsDetails.map((clinic) => ({
						accountid: clinic.id,
						name: clinic.name,
						ta_bypasssurcharges: clinic.ta_bypasssurcharges,
					}));
					set(() => ({ rawClinics: transformedClinics }));
				},
				resetClinics: () => set(() => initialState),
			}),
			{
				name: 'clinic-store',
				// ✅ blacklist example
				// partialize: (state) => ({
				// 	clinics: state.clinics, // persist only visible clinics, not raw/unassigned
				// 	current: state.current,
				// }),
			},
		),
		{ name: 'ClinicStore' },
	),
);
